import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=075748cc&"
import script from "./UserDropdown.vue?vue&type=script&lang=ts&"
export * from "./UserDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/app/components/base/Button.vue').default,AccountMenuList: require('/app/components/account/MenuList.vue').default})
